module.exports = __webpack_public_path__ + "media/brand/LifekiveLogo-8cda224e.png";